// import { appApi } from "@/api/app"
import router from "../../router"
export default {
  namespaced: true,
  state: {
    userInfo: null,
    token: '',
    refreshNav:false,
    isCode:sessionStorage.getItem('isCode')?sessionStorage.getItem('isCode'):true,
    phoneNum:sessionStorage.getItem('phoneNum')?sessionStorage.getItem('phoneNum'):"",
    placeholder:sessionStorage.getItem('placeholder')?sessionStorage.getItem('placeholder'):"请输入手机号/账号",
    code:sessionStorage.getItem('code')?sessionStorage.getItem('code'):"",
    phoneCode:sessionStorage.getItem('phoneCode')?sessionStorage.getItem('phoneCode'):"",
    forGetcode:sessionStorage.getItem('forGetcode')?sessionStorage.getItem('forGetcode'):false,
    checkd:sessionStorage.getItem('checkd')?sessionStorage.getItem('checkd'):false,
    selected:sessionStorage.getItem('selected')?sessionStorage.getItem('selected'):false,
    isReady:sessionStorage.getItem('isReady')?sessionStorage.getItem('isReady'):false,
    isRegister:sessionStorage.getItem('isRegister')?sessionStorage.getItem('isRegister'):false,
    isRemeber:sessionStorage.getItem('isRemeber')?sessionStorage.getItem('isRemeber'):false,
    needCode:'',//补全监护人信息code
  },
  mutations: {
    SET_USERINFO(state, data) {
      state.userInfo = data
    },
    SET_TOKEN(state, data) {
      state.token = data
    },
    SET_ISCODE(state, data) {
      state.isCode = data
    },
    SET_phoneNum(state, data) {
      state.phoneNum = data
    },
    SET_placeholder(state, data) {
      state.placeholder = data
    },
    SET_code(state, data) {
      state.code = data
    },
    SET_phoneCode(state, data) {
      state.phoneCode = data
    },
    SET_checkd(state, data) {
      state.checkd = data
    },
    SET_selected(state, data) {
      state.selected = data
    },
    SET_forGetcode(state, data) {
      state.forGetcode = data
    },
    SET_isReady(state, data) {
      state.isReady = data
    },
    SET_isRegister(state, data) {
      state.isRegister = data
    },
    SET_isRemeber(state, data) {
      state.isRemeber = data
    },
    SET_refreshNav(state, data) {
      state.refreshNav = data
    },
    SET_NEEDCODE(state, data) {
      state.needCode = data
    },
  },
  actions: {
    
  },
}